import { render, staticRenderFns } from "./CAxAAMxClarificationsPage.vue?vue&type=template&id=81959908"
import script from "./CAxAAMxClarificationsPage.vue?vue&type=script&lang=js"
export * from "./CAxAAMxClarificationsPage.vue?vue&type=script&lang=js"
import style0 from "./CAxAAMxClarificationsPage.vue?vue&type=style&index=0&id=81959908&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports